// extracted by mini-css-extract-plugin
export default {"rating":"xG-z","numberOfStars":"yG-z","count":"zG-z","barGraphSpacing":"AG-z","barGraph":"BG-z"};